import {useMutation} from '@tanstack/react-query'
import {httpResendConfirmationEmail} from '@features/settings/http/settings.http.ts'
import {errorHandler} from '@utilities/helpers.ts'

export const useResendConfirmationEmail = ({onSuccess}: {onSuccess: () => void}) => {
    return useMutation({
        mutationFn: () =>
            httpResendConfirmationEmail({
                params: {
                    response_type: 'extended'
                }
            }),
        onError: errorHandler,
        onSuccess
    })
}
